import { useEffect, useState, ComponentProps, useCallback } from 'react';
import { inject, observer } from 'mobx-react';
import { SimpleSelectInput } from '../forms';
import { InsuranceDocStore, insuranceDocStoreActions } from 'modules/orders/store/insuranceDocs/insuranceDocStore';

interface DocTypeStatusSelectorProps extends ComponentProps<typeof SimpleSelectInput> {
  orderId: string;
  docStatusRefValueIds?: number[], // В каких статусах показывать страховые документы
  insuranceDocStore?: InsuranceDocStore;
}

const DocTypeStatusSelector = (props:DocTypeStatusSelectorProps) => {
  const {
    insuranceDocStore,
    orderId,
    docStatusRefValueIds,
    // addPartnerId, excludedValues,
    // addPartnerName, serviceIds, 
    disabled, 
    ...rest
  } = props;

  const { insuranceDocs, insuranceDocsByOrderId } = insuranceDocStore;
  
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(    
    () => {
      if ( orderId !== insuranceDocsByOrderId ) {
        try { setLoading(true); 
          insuranceDocStoreActions.getInsuranceDocs(orderId);
        }
        finally {
          setLoading(false);
        }
      };
    }, [orderId]);

  const filterInsuranceDocs = () => {
    return docStatusRefValueIds 
      ? insuranceDocs.filter( v => docStatusRefValueIds.includes(v.docStatusRefValueId) ) 
      : insuranceDocs;
  }

  useEffect(() => {
    loadData();
  }, [loadData, orderId]);

  return (
    <SimpleSelectInput
      { ...rest }
      name={ props.name ?? 'orderDocTypeStatusId' }
      data={ filterInsuranceDocs() }
      dataTitle='docTypeRefValueName'
      dataValue='id'
      loading={ loading }
      sort
      disabled={ disabled }
    />
  );
};

export default inject('insuranceDocStore')(observer(DocTypeStatusSelector));
